import { createRoot } from 'react-dom/client';
import App from './App';
import datadogActions from 'lib/datadog';
import 'reflect-metadata';

datadogActions.initDatadogRum();

const container = document.getElementById('app');
if (!container) {
  throw new Error('React container not found');
}

const root = createRoot(container);
root.render(<App />);
